import { FC } from 'react';

import { NbCard, NbPageHeader } from '@/components/Neobrut';

const FAQ_ITEMS: { q: string; a: React.ReactNode }[] = [
  {
    q: '¿La app tiene algún costo?',
    a: 'No, la app es completamente gratuita. Fue creada sin fines de lucro para ayudar a conectar a personas que perdieron o encontraron mascotas.',
  },
  {
    q: '¿Cómo publico una mascota perdida o encontrada?',
    a: 'Registrate, ingresá la información básica del animal (foto, zona, características, etc.) y publicala en la categoría correspondiente. Es rápido.',
  },
  {
    q: '¿Qué tipo de animales puedo reportar?',
    a: 'Cualquier mascota: perros, gatos, aves u otros animales domésticos que hayan sido encontrados o perdidos.',
  },
  {
    q: '¿Es necesario registrarme para usar la app?',
    a: 'No para explorar publicaciones. Sí para crear publicaciones o interactuar con ellas.',
  },
  {
    q: '¿Qué hago si encuentro a mi mascota en la app?',
    a: 'Usá la función de contacto para hablar directamente con la persona que publicó el anuncio.',
  },
  {
    q: '¿Qué medidas de seguridad debo tomar al reunirme con alguien por una mascota?',
    a: (
      <>
        Coordiná el encuentro en un lugar público y comunicate por medios seguros.{' '}
        <strong>IMPORTANTE:</strong> siempre verificá que la persona pueda demostrar que es la
        dueña legítima del animal.
      </>
    ),
  },
  {
    q: '¿Qué publicaciones NO están permitidas?',
    a: 'No se permite publicar animales en venta o en adopción — no es el objetivo de la app. Esas publicaciones se dan de baja y se elimina la cuenta del usuario que las haya creado.',
  },
  {
    q: '¿Cómo puedo reportar un anuncio inapropiado o falso?',
    a: 'Usá la opción de "Reportar" en cada publicación. Nuestro equipo revisa el caso y toma las medidas necesarias.',
  },
  {
    q: '¿Qué pasa si encuentro a mi mascota?',
    a: (
      <>
        Marcá la publicación como "caso resuelto": Menú → Mi cuenta → Mis publicaciones → los 3
        puntos sobre la publicación → <b>"¿Resuelto?"</b>.
      </>
    ),
  },
];

export const FAQ: FC = () => {
  return (
    <div className="mx-auto w-full max-w-2xl lg:max-w-3xl pb-10">
      <NbPageHeader
        slug="/ faq"
        title={
          <>
            Preguntas
            <br />
            <span className="nb-highlight">frecuentes.</span>
          </>
        }
        tone="plain"
      />
      <div className="flex flex-col gap-3 px-4 pt-4">
        {FAQ_ITEMS.map((item, i) => (
          <NbCard key={i} size="sm" className="p-4">
            <div
              className="text-[10px] font-bold uppercase tracking-[0.08em] opacity-60"
              style={{ fontFamily: '"JetBrains Mono", monospace' }}
            >
              / {String(i + 1).padStart(2, '0')}
            </div>
            <div className="font-display mt-1 text-[18px] leading-tight">{item.q}</div>
            <p className="mt-2 text-[14px] leading-snug">{item.a}</p>
          </NbCard>
        ))}
      </div>
    </div>
  );
};
